import React from 'react'
import PropTypes from 'prop-types'

import { Switch, Route, Redirect } from 'react-router-dom'

import { Container } from '@material-ui/core'

import FourOhFourRoute from 'routes/status/FourOhFour'
import VisitsViewRoute from './View'
import VisitsUpcomingRoute from './Upcoming'
import VisitsLayout from './VisitsLayout'

import './index.scss'

const renderVisitsLayoutRoute = (children) => (
  <div className="visits-layout-container">
    <Container
      className="visits-layout-stage"
      maxWidth={false}
    >
      <VisitsLayout>{children}</VisitsLayout>
    </Container>
  </div>
)
const VisitsRoute = () => {
  const ROOT_PATH = import.meta.env.BASE_URL
  return (
    <div className="route-calendar">
      <Switch>
        <Route
          exact
          path={`${ROOT_PATH}/recruit/visits/view/week`}
          render={(props) =>
            renderVisitsLayoutRoute(
              <VisitsViewRoute
                {...props}
                lens="week"
              />,
            )
          }
        />
        <Route
          exact
          path={`${ROOT_PATH}/recruit/visits/view/month`}
          render={(props) =>
            renderVisitsLayoutRoute(
              <VisitsViewRoute
                {...props}
                lens="month"
              />,
            )
          }
        />
        <Route
          exact
          path={`${ROOT_PATH}/recruit/visits/upcoming`}
          render={(props) => renderVisitsLayoutRoute(<VisitsUpcomingRoute {...props} />)}
        />
        <Redirect
          exact
          from={`${ROOT_PATH}/recruit/visits`}
          to={`${ROOT_PATH}/recruit/visits/view/week`}
        />
        <FourOhFourRoute />
      </Switch>
    </div>
  )
}
VisitsRoute.propTypes = {
  history: PropTypes.object.isRequired,
}
export default VisitsRoute
